export const environment = {
  production: false,
  apiUrl: "https://b2b2c-api-uat.awpassistance.in",
  payuUrl: "https://sboxcheckout-static.citruspay.com/bolt/run/bolt.min.js",
  nsmCount: 1,
  rsmCount: 5,
  asmCount: 25,
  financeCount: 1,
  gCaptchaKey: "6Ld3mpgqAAAAABdQZbiDeN08g2BvQtw9M-jQmlm3",
  gCaptchaSecret: "6Ld3mpgqAAAAAGZdMiRsAzobYdsxDlNDnUVd9uFk",
  maxvehicleAge: 8,
  onePayuUrl: "https://test.payu.in/_payment",
  onePayuKey: "oZ7oo9",
  onePayuSalt: "UkojH5TS",  
  responseKey:"511536EF-F270-4058-80CA-1C89C192F69A",
};
